import { message } from 'antd'
import * as Sentry from '@sentry/react'

// 通用错误处理函数
export function handleApiError(error: unknown, defaultMessage = '操作失败') {
  console.error('API Error:', error)

  // 上报错误到 Sentry
  if (error instanceof Error) {
    Sentry.captureException(error)
    message.error(error.message || defaultMessage)
  } else if (typeof error === 'string') {
    Sentry.captureMessage(error, 'error')
    message.error(error || defaultMessage)
  } else {
    Sentry.captureException(new Error(defaultMessage))
    message.error(defaultMessage)
  }
}

// 检查响应状态码并处理常见错误
export function checkResponseStatus(code: string, msg: string) {
  switch (code) {
    case '200':
    case 'success':
      return true
    case '401':
      message.error('未授权，请重新登录')
      // 可以在这里处理登录跳转
      return false
    case '403':
      message.error('权限不足')
      return false
    case '404':
      message.error('资源不存在')
      return false
    case '500':
      message.error('服务器内部错误')
      return false
    default:
      message.error(msg || '未知错误')
      return false
  }
}

// 格式化 API 错误信息
export function formatApiError(error: any): string {
  if (error?.response?.data?.msg) {
    return error.response.data.msg
  }
  if (error?.message) {
    return error.message
  }
  if (typeof error === 'string') {
    return error
  }
  return '网络错误，请稍后重试'
}

// API 请求错误上报到 Sentry
export function reportApiError(
  error: unknown,
  requestInfo: {
    url: string
    method: string
    code?: string
    message?: string
  },
) {
  // 创建错误上下文
  const context = {
    tags: {
      errorType: 'api_request',
      apiMethod: requestInfo.method,
      apiUrl: requestInfo.url,
      responseCode: requestInfo.code,
    },
    extra: {
      url: requestInfo.url,
      method: requestInfo.method,
      responseCode: requestInfo.code,
      responseMessage: requestInfo.message,
    },
  }

  // 设置上下文并上报错误
  Sentry.withScope((scope) => {
    scope.setTags(context.tags)
    scope.setExtras(context.extra)

    if (error instanceof Error) {
      Sentry.captureException(error)
    } else {
      Sentry.captureMessage(
        `API请求失败: ${requestInfo.method} ${requestInfo.url} - ${requestInfo.message || 'Unknown error'}`,
        'error',
      )
    }
  })
}
